// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/optimism-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Contains info about estimated gas cost of a transaction on both L1 and L2
 * @export
 * @interface OptimismGasEstimate
 */
export interface OptimismGasEstimate {
    /**
     * 
     * @type {string}
     * @memberof OptimismGasEstimate
     */
    gasLimit: string;
    /**
     * 
     * @type {string}
     * @memberof OptimismGasEstimate
     */
    l1GasLimit: string;
}

/**
 * Check if a given object implements the OptimismGasEstimate interface.
 */
export function instanceOfOptimismGasEstimate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "gasLimit" in value;
    isInstance = isInstance && "l1GasLimit" in value;

    return isInstance;
}

export function OptimismGasEstimateFromJSON(json: any): OptimismGasEstimate {
    return OptimismGasEstimateFromJSONTyped(json, false);
}

export function OptimismGasEstimateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptimismGasEstimate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'gasLimit': json['gasLimit'],
        'l1GasLimit': json['l1GasLimit'],
    };
}

export function OptimismGasEstimateToJSON(value?: OptimismGasEstimate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'gasLimit': value.gasLimit,
        'l1GasLimit': value.l1GasLimit,
    };
}

